




import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '@/author/constants';
import { AnswerType } from '@/author/components/Quiz/AnswerTypes';

@Component
export default class DropDownOption extends Vue {
  @Prop() text!: String;
  @Prop() answerType!: AnswerType;

  get answer(): AnswerType {
    return this.answerType;
  }
}
